import { ConfigProvider, theme as antdTheme } from 'antd';
import { createGlobalStyle } from 'antd-style';

import { ThemeColors, ThemeFont } from '../theme';

export const BUTTON_DARK_THEME_CLASSNAME = 'ButtonTheme--DarkSimple';

const darkSimpleButtonTokens = token => ({
  components: {
    Button: {
      defaultShadow: 'none',
      defaultBg: ThemeColors.COLOR_GREY_DARK1_1,
      defaultBorderColor: ThemeColors.COLOR_GREY_DARK5,
      defaultColor: ThemeColors.COLOR_GREY_BLUISH,
      defaultHoverBg: ThemeColors.COLOR_GREY_DARK1_1,
      defaultHoverBorderColor: ThemeColors.COLOR_GREY_DARK5,
      defaultHoverColor: ThemeColors.COLOR_GREY_BLUISH,
      defaultActiveBg: ThemeColors.COLOR_GREY_DARK1_1,
      defaultActiveBorderColor: ThemeColors.COLOR_GREY_DARK5,
      defaultActiveColor: ThemeColors.COLOR_GREY_BLUISH,

      colorTextDisabled: ThemeColors.COLOR_GREY_BLUISH,
      colorBgContainerDisabled: ThemeColors.COLOR_GREY_DARK1_1,
      borderColorDisabled: ThemeColors.COLOR_GREY_DARK5,

      colorPrimary: ThemeColors.COLOR_BLUE3, // background color
      colorPrimaryHover: ThemeColors.COLOR_BLUE3,
      colorPrimaryActive: ThemeColors.COLOR_BLUE3,
      primaryColor: token.colorWhite, // text color
      primaryShadow: 'none',

      ghostBg: 'transparent',
      defaultGhostBorderColor: ThemeColors.COLOR_GREY7_1,
      defaultGhostColor: ThemeColors.COLOR_GREY7_1,

      fontSizeSM: token.fontSize,
      fontSize: token.fontSizeLG,
      fontFamily: ThemeFont.FONT_FAMILY3,
    },
  },
});

const DarkSimpleButtonStyles = createGlobalStyle(({ theme }) => ({
  [`.${BUTTON_DARK_THEME_CLASSNAME}`]: {
    '.ant-btn': {
      '&.ant-btn-primary, &.ant-btn-color-primary': {
        '&:not(:disabled):not(.ant-btn-disabled):focus': {
          backgroundColor: ThemeColors.COLOR_BLUE3,
        },
        '&.ant-btn-disabled, &.disabled, &[disabled]': {
          '&, &:hover, &:focus': {
            backgroundColor: ThemeColors.COLOR_BLUE3,
            color: theme.colorWhite,
            opacity: 0.53,
          },
        },
      },
    },
  },
}));

export default function DarkSimpleButtonTheme({ children }) {
  const { token } = antdTheme.useToken();

  return (
    <ConfigProvider theme={darkSimpleButtonTokens(token)}>
      <DarkSimpleButtonStyles />
      <div className={BUTTON_DARK_THEME_CLASSNAME}>{children}</div>
    </ConfigProvider>
  );
}
